import {
  ArrowTopRightOnSquareIcon,
  LightBulbIcon,
} from '@heroicons/react/24/outline';
import ButtonExternal from '@teetsh/app/src/components/Buttons/ExternalLink';
import TwoColumnsCardSidebar from '@teetsh/app/src/components/TwoColumnsCardSidebar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import 'twin.macro';

export const GREAT_QUESTION_TO_ASK_URL =
  'https://greatquestion.co/teetsh/zqpjwn3x/direct';

export function ShareIdeas() {
  const { t } = useTranslation(['userSettings', 'common']);

  return (
    <TwoColumnsCardSidebar.Section
      title={
        <div tw="flex items-center gap-2">
          <LightBulbIcon tw="h-6 w-6" />
          {t('userSettings:contact.shareIdeas.title')}
        </div>
      }
    >
      <p tw="text-base mb-4">
        <span tw="font-semibold">
          {t('userSettings:contact.shareIdeas.question')}
        </span>
        {t('userSettings:contact.shareIdeas.description')}
      </p>
      <div tw="flex gap-2 flex-wrap">
        <ButtonExternal
          href="https://feedback.teetsh.com/"
          intent="primary"
          target="_blank"
          outlined
          icon={ArrowTopRightOnSquareIcon}
        >
          {t('userSettings:contact.shareIdeas.platformButton')}
        </ButtonExternal>
        <ButtonExternal
          href={GREAT_QUESTION_TO_ASK_URL}
          intent="primary"
          target="_blank"
          outlined
          icon={ArrowTopRightOnSquareIcon}
        >
          {t('userSettings:contact.shareIdeas.appointmentButton')}
        </ButtonExternal>
      </div>
    </TwoColumnsCardSidebar.Section>
  );
}
